import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { PencilIcon } from 'components';
import { Button } from 'reactstrap';
export function StoresList({ id }) {

  const URL_NEW_REGISTER = "new";

  let { url } = useRouteMatch();

  const getNewIdStore = () => {
    return URL_NEW_REGISTER;
  }

  if (id) {
    return (
      <Link to={`${url}/${id}`}>
        <PencilIcon />
      </Link>
    );
  }
  return (
    <Link to={`${url}/${getNewIdStore()}`}>
      <Button color="primary" className="px-4">
        + Adicionar
       </Button>
    </Link>
  );

};
